import NotificationLog from "../../components/Notificationlog/index";

export default function NotificationLogpage() {
    return (
        <>
            <NotificationLog />
        </>
    );
}
